import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { Nav, Tab, Tabs } from "react-bootstrap";
import ContactsIcon from "../../assets/icons/contact_edit.svg2";
import TicketingIcon from "../../assets/icons/tiket_reporting.svg2";
import WhiteButtonsContainer from "../Common/WhiteButtonsContainer";
import Subheading from "../Common/Subheading";
import TicketReporting from "./TicketReporting";
import TicketReportingOthers from "./TicketReportingOthers";
import StyledTabContainer from "../Common/StyledTabContainer";
import HelpButton from "../HelpContent/HelpButton";
import WhiteButtonDropdown from "../Common/WhiteButtonDropdown";

export default function TicketReportingPage() {
  const location = useLocation();
  const { tab } = useParams();
  const navigate = useNavigate();

  return (
    <div>
      <div className="d-flex justify-content-between">
        <div className="d-flex align-items-center">
          <Subheading
            Icon={TicketingIcon}
            heading="Ticketing Data"
            subheading="Select and monitor your tickets."
          />
        </div>
        <div className="">
          <WhiteButtonDropdown
            toggleHeading={"Actions"}
            toggleSubheading={"Ticketing Data"}
          >
            <WhiteButtonsContainer
              buttons={[
                {
                  icon: ContactsIcon,
                  as: "RRLink",
                  heading: "Topics",
                  subheading: "Manage",
                  to: "/reporting/topics",
                },
                {
                  icon: ContactsIcon,
                  as: "RRLink",
                  heading: "Templates",
                  subheading: "Manage",
                  to: "/reporting/templates",
                },
              ]}
            />
          </WhiteButtonDropdown>
        </div>
      </div>
      <StyledTabContainer id="ticketing-tabs" isBackgroundFixed>
        <Tab.Container
        
          id="ticketing-tabs"
          activeKey={tab || "tickets"}
          mountOnEnter
          onSelect={(k) => {
            navigate(`/reporting/ticketing/${k}`);
          }}
        >
          <Nav variant="tabs" className="mb-n2 mx-0">
            <Nav.Item className=" d-flex justify-content-between">
              <Nav.Link
                eventKey={"tickets"}
                className="fw-bold d-flex justify-content-between rounded-top-4 border-0 p-3 px-5 text-center"
              >
                <div>Tickets</div>
              </Nav.Link>
            </Nav.Item>
            <Nav.Item className=" d-flex justify-content-between">
              <Nav.Link
                eventKey={"data"}
                className="fw-bold d-flex justify-content-between rounded-top-4 border-0 p-3 px-5 text-center"
              >
                <div>Data</div>
              </Nav.Link>
            </Nav.Item>
          </Nav>
          <Tab.Content>
            <Tab.Pane eventKey="tickets" title="Tickets">
              <TicketReporting />
            </Tab.Pane>
            <Tab.Pane eventKey="data" title="Data">
              <TicketReportingOthers />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </StyledTabContainer>
    </div>
  );
}
